$(document).ready(function() {
    // owl-carousel3
    var owl = $('.owl-banners');
    owl.owlCarousel({
      items: 1,
      margin: 0,
      // center: true,
      nav: false,
      loop: true,
      // autoplay:true,
      autoplayTimeout:2300,
    })
    
    // owl-products
    var owl = $('.owl-products');
    owl.owlCarousel({
      margin: 20,
      nav: false,
      loop: false,
      dots: false,
      autoplay: false,
      touchDrag: false,
      mouseDrag: false,
      pullDrag: false,
      autoplayTimeout:2300,
      responsive: {
        0: {
          items: 2,
          margin: 10,
          loop: true,
          autoplay: true,  
          touchDrag: true,
          mouseDrag: true,
          pullDrag: true,
          dots: true,
        },
        768: {
          items: 3,
          loop: true,
          autoplay: true,  
          touchDrag: true,
          mouseDrag: true,
          pullDrag: true,
          dots: true,
        },
        992: {
          items: 4,
        },
      }
    })

    // owl-testimonial
    var owl = $('.owl-testimonial');
    owl.owlCarousel({
      margin: 30,
      center: false,
      nav: false,
      loop: true,
      autoplay:true,
      autoplayTimeout:2300,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        768: {
          items: 2
        },
        992: {
          items: 3  
        }
      }
    })

    var $owl = $('.insta-carousel2');
    // init carousel (example settings — keep your own if different)
    $owl.owlCarousel({
      autoplay: true,
      loop: true,
      margin: 50,
      center: true,
      slideTransition: 'linear',
      dots: true,
      nav: false,
      responsive: {
        0: { items: 2 },
        500: { items: 2 },
        768: { items: 3 },
        992: { items: 4 }
      }
    });
    // Function to control videos
    function controlVideos() {
      // Pause ALL videos first
      $owl.find('video').each(function () {
        this.pause();
      });

      // Play only the center video
      var $centerVideo = $owl.find('.owl-item.center video');
      if ($centerVideo.length) {
        $centerVideo[0].play();
      }
    }

    // Run on init
    controlVideos();

    // Run every time the carousel moves
    $owl.on('translated.owl.carousel', function () {
      controlVideos();
    });


    $('.open-btns').click(function() {
        $('.navbar-backdrop').addClass('d-block');
    });
    $('.close-btns').click(function() {
        $('.navbar-backdrop').removeClass('d-block');
        $('.navbar-backdrop').addClass('d-none');
    });

    // OR

    // menu backdrop
    // document.querySelector('.open-btns').addEventListener('click', function () {
    //   let el = document.querySelector('.navbar-backdrop');
    //   el.classList.remove('d-nones');
    //   el.classList.add('d-blocks');
    // });

    document.querySelector('.close-btns').addEventListener('click', function () {
      let el = document.querySelector('.navbar-backdrop');
      el.classList.remove('d-blocks');
      el.classList.add('d-nones');
    });

    //When any child accordion is clicked
    $('.card .collapse').on('show.bs.collapse', function () {
      //Find sibling .collapse in the same parent .card-body and hide them
      $(this).closest('.card-body').find('.collapse.show').not(this).collapse('hide');
    });

    // loading 
    $(document).ready(function () {
      preloaderFadeOutTime = 2000;
      function hidLoader(){
        var loader = $('#myModal1');
        loader.fadeOut(preloaderFadeOutTime);
      }
      hidLoader();
    });

    // navbar scroll
    $(document).scroll(function () {
      var scroll = $(this).scrollTop();
      // var topDist = $(".Leaf-Authenticity-sec").position();
      if (scroll > 300) {
          $('.navs').addClass("navs-top");
          $('.scroll-tops').addClass("scroll-top");
      } else {
        $('.navs').removeClass("navs-top");
        $('.scroll-tops').removeClass("scroll-top");
      }
    });

    $(window).on('scroll', function () {
      var scrolls = $(this).scrollTop();

      $('section').each(function () {
        var $section = $(this);
        var topDist = $section.offset().top - 300;

        if (scrolls > topDist) {
          $section.find('.rotates-anim').addClass('rotats');
          $section.find('.zooms-anim').addClass('zooms');
          $section.find('.right-fad-anim').addClass('right-fad');
        } else {
          $section.find('.rotates-anim').removeClass('rotats');
          $section.find('.zooms-anim').removeClass('zooms');
          $section.find('.right-fad-anim').removeClass('right-fad');
        }
      });
    });

    // $(document).scroll(function () {
    //   var scroll = $(this).scrollTop();
    //   if (scroll > 1400) {
    //       $('.scroll-tops').addClass("scroll-top");
    //   } else {
    //     $('.scroll-tops').removeClass("scroll-top");
    //   }
    // });

    // top scroll
    $('#top').click(function () {
      $('body,html').animate({
          scrollTop: 0
      }, 2000);
    });
  })